<nav class="side-nav" [class.collapsed]="!sideNavService.isOpen()">
    <button type="button" class="toggle-btn" (click)="sideNavService.toggle()">
        <div [innerHTML]="toggleBackground"></div>
        <span class="toggle-svg" [innerHTML]="sideNavService.isOpen() ? toggleChevronLeft : toggleChevronRight"></span>
    </button>

    <div class="sidenav-header">
        <div class="header-logo" [class.expanded]="sideNavService.isOpen()">
            <div class="logo-collapsed" [innerHTML]="logoCollapsed"></div>
            <div class="logo-expanded nav-label" [innerHTML]="logoExpanded"></div>
        </div>
        <div class="header-text">
            <span>CRM</span>
        </div>
    </div>

    @if (source()) {
        <div class="content">
            <div class="menu-scroll">
                @for (group of mainGroups(); track group.id) {
                    <ul class="menu-group">
                        @for (item of group.menuItems; track item.id) {
                            @if (item.isVisible) {
                                <li class="menu-item" [class.active]="isActive(item.link)">
                                    <a
                                        tabindex="0"
                                        class="menu-link"
                                        [routerLink]="item.link"
                                        [attr.href]="item.link"
                                        [attr.title]="!sideNavService.isOpen() ? item.name : null"
                                    >
                                        <span class="icon" [innerHTML]="item.icon"></span>
                                        <span class="nav-label">{{ item.name }}</span>
                                    </a>
                                </li>
                            }
                        }
                    </ul>
                }
            </div>

            @for (group of footerGroups(); track group.id) {
                <ul class="menu-group footer">
                    @for (item of group.menuItems; track item.id) {
                        @if (item.isVisible) {
                            <li class="menu-item" [class.active]="isActive(item.link)">
                                <a
                                    tabindex="0"
                                    class="menu-link"
                                    [routerLink]="item.link"
                                    [attr.href]="item.link"
                                    [attr.title]="!sideNavService.isOpen() ? item.name : null"
                                >
                                    <span class="icon" [innerHTML]="item.icon"></span>
                                    <span class="nav-label">{{ item.name }}</span>
                                </a>
                            </li>
                        }
                    }
                </ul>
            }
        </div>
    }
</nav>
